<template>
  <section class="constrain-65">
    <p class="text-grey">{{ tn("priceWarning") }}</p>
    <p v-if="props.showAutoRenewLinks">
      <button class="btn-link left-link" @click="goToHelpDeactivatingAutoRenewal()">
        {{ tn("helpLinkDeactivatingAutoRenewal") }}
      </button>
    </p>
    <p v-if="props.showAutoRenewLinks" class="text-grey">{{ tn("autoRenewDisclaimer") }}</p>
    <p class="text-grey">{{ tn("byContinuing") }}</p>
    <ul>
      <li class="mb-0">
        <button class="btn-link left-link" @click="goToTerms()">{{ tn("helpLinkTermsOfService") }}</button>
      </li>
      <li>
        <button class="btn-link left-link" @click="goToPrivacy()">{{ tn("helpLinkPrivacyPolicy") }}</button>
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
import { getUrl } from "@/common/getUrl";
import { logEvent } from "@/common/logger";
import { t } from "@/i18n";

const componentName = "BuyDisclaimersComponent";

logEvent("created", componentName);

const props = defineProps({
  showAutoRenewLinks: {
    type: Boolean,
    default: true,
    required: true,
  },
});

function tn(v: string, params?: Record<string, unknown>): string {
  return t(`${componentName}.${v}`, params);
}

function goToHelpDeactivatingAutoRenewal() {
  logEvent("goToHelpDeactivatingAutoRenewal");
  const link = getUrl("BUY_DEACTIVATION_URL");
  window.open(link, "_blank");
}

function goToTerms() {
  logEvent("goToTerms");
  const link = getUrl("BUY_TERMS_URL");
  window.open(link, "_blank");
}

function goToPrivacy() {
  logEvent("goToPrivacy");
  const link = getUrl("BUY_PRIVACY_URL");
  window.open(link, "_blank");
}
</script>

<style scoped lang="css">
@import "@/styles/variables.css";
</style>
